import React, { createContext, useEffect, useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { UserContext } from './UserContext';
import { SrxApi } from '../api/SrxApi';

export const SelectedPharmaciesContext = createContext();

export const SelectedPharmaciesProvider = (props) => {

    let history = useHistory();

    const { faciToken, setFaciToken } = useContext(UserContext);

    const [selectedPharmacies, setSelectedPharmacies] = useState([]);

    const [pharmacies, setPharmacies] = useState([])

    useEffect(() => {
        if(faciToken){
            // Ensure Authorization header is set on SrxApi
            SrxApi.defaults.headers.common['Authorization'] = 'bearer ' + faciToken;
            
            SrxApi.get('/pharmacies')
            .then(res => {
                // Ensure we always set an array
                const pharmaciesData = res.data?.pharmacies || res.data;
                if (Array.isArray(pharmaciesData)) {
                    setPharmacies(pharmaciesData);
                } else {
                    console.warn('Pharmacies data is not an array:', pharmaciesData);
                    setPharmacies([]);
                }
            })
            .catch(err => {
                console.error('Error fetching pharmacies:', err);
                // Set empty array on error to prevent undefined issues
                setPharmacies([]);
                if(err.response?.status === 401){
                    localStorage.removeItem('FACI_TOKEN');
                    setFaciToken(null);
                    history.replace('/account/login')
                }
            })
        } else {
            setSelectedPharmacies([]);
            setPharmacies([]);
        }
    }, [faciToken])
    
    return (
        <SelectedPharmaciesContext.Provider value={{ selectedPharmacies, setSelectedPharmacies, pharmacies }}>
            {props.children}
        </SelectedPharmaciesContext.Provider>
    );
}